<template>
  <div class="search-horizontal" :style="peopleWidth">
    <el-input :placeholder="placeholderText" v-model="searchtext" @keyup.enter.native="toSearch">
      <i slot="suffix" class="el-input__icon el-icon-search" @click="toSearch"></i>
    </el-input>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "searchHorizontal",
  data() {
    return {
      searchtext: this.searchData,
      assetType: this.ifVideo ? 3 : 1,
      peopleWidth: ""
    };
  },
  created() {
    if (this.showPeople) {
      this.peopleWidth = "width: 680px";
    }
  },
  props: {
    ifVideo: {
      type: Boolean,
      default() {
        return false;
      }
    },
    searchData: {
      type: String,
      default() {
        return "";
      }
    }
  },
  methods: {
    toSearch() {
      this.ifVideo;
      this.assetType;
      if (this.$route.path == "/search") {
        this.$router.push({
          path: "/search",
          query: {
            isEnglish: this.isEnglish,
            type: 0,
            asset_type: this.assetType,
            text: encodeURI(this.searchtext)
          }
        });
        location.reload();
      } else {
        this.$router.push({
          path: "/search",
          query: {
            isEnglish: this.isEnglish,
            type: 0,
            asset_type: this.assetType,
            text: encodeURI(this.searchtext)
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",
      "logo_src",
      "hidefooter",
      "column_switch",
      "isGaonS",
      "isEnglish",
      "showPeople"
    ]),

    placeholderText() {
      if (this.isGaonS && this.isEnglish) {
        if (this.ifVideo) {
          return "The input video ID, keywords to search";
        } else {
          return "The input Photo ID, keywords to search";
        }
      } else {
        if (this.ifVideo) {
          return "输入视频ID、关键词进行搜索";
        } else {
          return "输入图片ID、关键词进行搜索";
        }
      }
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.search-horizontal {
  width: 100%;
}
</style>

<style lang="less">
.search-horizontal {
  .el-input--suffix .el-input__inner {
    height: 60px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 1);
    border: 0;
  }
  .el-input__suffix {
    margin-right: 30px;
    cursor: pointer;
  }
  .el-input__icon {
    font-size: 22px;
    color: #333;
  }
  .el-input__icon:hover {
    color: #3366cc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/searchHorizontal.vue